// todo, node_modules/@carbon/layout/es/index.js values are converted to em. how to extract as px?
// https://carbondesignsystem.com/guidelines/2x-grid/overview/#breakpoints
export default {
  large: 1056
};